
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankings/[id]/products",
      function () {
        return require("private-next-pages/rankings/[id]/products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankings/[id]/products"])
      });
    }
  